/**
 * テキスト中のプレースホルダーを置換する
 * 
 * @param {string} text - プレースホルダーを含む元のテキスト
 * @param {Object} replacements - プレースホルダーとその置換値のマッピング（例: { ":name": <b>John</b>, ":age": 30 }）
 * @returns {Array} 文字列とJSX要素の混在配列（Reactで直接レンダリング可能）
 * 
 * 使用例:
 * replacePlaceholders("Hello :name! You are :age years old.", { ":name": <b>John</b>, ":age": 30 })
 * → ["Hello ", <b>John</b>, "! You are ", 30, " years old."]
 * 
 * 注意: 配列で返す理由について
 * - Reactは文字列とJSX要素を混在させる場合、配列形式で渡す必要がある
 * - 文字列結合で返すと、JSX要素が "[object Object]" として表示されてしまう
 * - 例: "Hello " + <b>John</b> + "!" → "Hello [object Object]!" (正しく表示されない)
 * - 配列で返すことで、Reactが各要素を適切にレンダリングできる
 */
export function replacePlaceholders(text, replacements) {
    if (!text || !replacements) return [text];
    
    let parts = [text]; // 結果を格納する配列
    
    // 各プレースホルダーを1つずつ処理
    for (const [find, replace] of Object.entries(replacements)) {
        const newParts = [];
        
        // 現在の各部分をチェック
        for (const part of parts) {
            if (typeof part === 'string' && part.includes(find)) {
                // プレースホルダーで分割
                const chunks = part.split(find);
                
                // 分割した文字列の間に置換値を挿入
                chunks.forEach((chunk, i) => {
                    if (chunk) newParts.push(chunk);
                    if (i < chunks.length - 1) newParts.push(replace);
                });
            } else {
                // プレースホルダーがない場合はそのまま
                newParts.push(part);
            }
        }
        
        parts = newParts;
    }

    return parts;
} 